'use client'

// Правая часть шапки публичных страниц (/words, /phrases, …). Страницы
// статические (ISR на сутки), сервер не знает, кто смотрит, — поэтому вход
// определяется в браузере по cookie сессии Supabase. Гостю — «Войти» и
// «Зарегистрироваться», вошедшему — путь к своим урокам и «Выйти», как в
// шапке приложения (QA 2026-09-24: вошедший видел гостевую шапку).

import Link from 'next/link'
import { useSyncExternalStore } from 'react'
import { LogoutButton } from '@/components/logout-button'
import { supabaseCookieName } from '@/lib/supabase/cookie-name'

function hasSessionCookie(): boolean {
  try {
    const name = supabaseCookieName()
    // Большая сессия режется @supabase/ssr на части: name.0, name.1, …
    return document.cookie.split(';').some((c) => {
      const k = c.trim().split('=')[0]
      return k === name || k.startsWith(name + '.')
    })
  } catch {
    return false
  }
}

const noop = () => () => {}

export function useSignedIn(): boolean {
  return useSyncExternalStore(noop, hasSessionCookie, () => false)
}

export function PublicNavActions() {
  const signedIn = useSignedIn()
  if (signedIn) {
    return (
      <div className="flex items-center gap-2 sm:gap-3">
        <Link
          href="/dashboard"
          className="tk-glass-btn tk-glass-coal inline-flex items-center justify-center rounded-2xl px-3 py-[11px] text-[13px] font-bold whitespace-nowrap sm:px-[22px] sm:text-sm"
        >
          Мои уроки
        </Link>
        <LogoutButton />
      </div>
    )
  }
  return (
    <div className="flex items-center gap-2 sm:gap-3">
      <Link href="/auth/login" className="tk-nav-link text-[15px] font-medium whitespace-nowrap">
        Войти
      </Link>
      {/* Уже 18rem по шапке (320 px в «Крупном») кнопка в одну строку не помещалась и
          уходила за правый край: там подпись в две строки (тикет 49). */}
      <Link
        href="/auth/sign-up"
        className="tk-glass-btn tk-glass-coal inline-flex items-center justify-center rounded-2xl px-3 py-[11px] text-[13px] font-bold whitespace-nowrap sm:px-[22px] sm:text-sm @max-[18rem]:px-2.5 @max-[18rem]:py-1.5 @max-[18rem]:text-center @max-[18rem]:leading-tight @max-[18rem]:whitespace-normal"
      >
        {/* Без слова "бесплатно": про оплату в шапке не пишем (пользователь 08.10.2026). */}
        Зарегистрироваться
      </Link>
    </div>
  )
}

// Кнопка в карточке-призыве внизу публичной страницы.
export function StartCta() {
  const signedIn = useSignedIn()
  return (
    <Link
      href={signedIn ? '/dashboard' : '/auth/sign-up'}
      className="tk-glass-btn tk-glass-coal inline-flex max-w-full items-center justify-center rounded-2xl px-[22px] py-[11px] text-center text-sm font-bold shrink-0 sm:whitespace-nowrap"
    >
      {signedIn ? 'Продолжить уроки' : 'Зарегистрироваться'}
    </Link>
  )
}
